import React, { useEffect, useState, useRef } from "react";
import { SectionCard } from "../study/course/SectionCard";
import Button from "../Button";
import { makeStyles } from "tss-react/mui";
import { useStudy } from "../../pages/study/hooks";
import { addAssignmentActivitiesByCourseAndAssignee } from "../../store/study/studyBaseApi";
import VideoPlayer from "../videoPlayer";
import { Box } from "@mui/material";

const useStyles = makeStyles()((theme) => ({
    root: {
        // display: 'flex',
        // justifyContent: 'space-between',
        // flexDirection: 'column',
        // height: '100%',
        [theme.breakpoints.up("md")]: {
            // top: "0px", // Applies only for md and larger
            // position: 'relative',
            // top: '-80px',
        },

    },
    actionBtn: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
        justifyContent: "center",
        display: "flex"
    },
    videoContainer: {
        width: '100%',
        margin: 'auto',
        maxWidth: '800px', // Max width for large screens
        aspectRatio: '16/9', // Maintains aspect ratio
    }
}));

const MIN_WATCH_THRESHOLD = 60;

export default function RecapVideoPlayer({ url, onPlay }) {
    const { classes } = useStyles();
    // const { setRecapWatchingCompleted, recapCompleted } = useStudy();

    // const handleTimeUpdate = (playerInstance) => {
    //     const videoElement = playerInstance;
    //     const targetTime = (MIN_WATCH_THRESHOLD / 100) * videoElement.duration();

    //     if (videoElement.currentTime() >= targetTime && !recapCompleted) {
    //         setRecapWatchingCompleted(true);
    //         console.log(`${MIN_WATCH_THRESHOLD}% of the video has been played`);
    //     }
    // };

    if (!url) return <></>;

    return (
        // <Box sx={{ height: '100%', }}>
        // <SectionCard style={{
        //         height: '100%', overflowY: 'scroll', '&::-webkit-scrollbar': {
        //             width: '6px',
        //         },
        //         '&::-webkit-scrollbar-track': {
        //             background: 'transparent',
        //             borderRadius: '10px',
        //         },
        //         '&::-webkit-scrollbar-thumb': {
        //             background: '#E1E4E6',
        //             borderRadius: '10px',
        //         },
        //         '&:hover, &:focus-within': {
        //             '&::-webkit-scrollbar-thumb': {
        //                 background: 'linear-gradient(193.28deg, #29ABE2 5.42%, #2DA2E2 12.18%, #398CE2 33.81%, #417EE2 54.77%, #447AE2 73.02%)',
        //                 width: '12px',
        //                 cursor: 'pointer',
        //             },
        //         },
        //         display: 'flex',
        //         justifyContent: 'flex-start',
        //         flexDirection: 'column',
        //         alignItems: 'center'
        //     }}>
        //     < VideoPlayer
        //         onPlay={onPlay}
        //         // onTimeUpdate={handleTimeUpdate}
        //         // width="100%"
        //         // height="100%"
        //         sources={[{ src: url }]}
        //     />
        //     </SectionCard>
        // </Box>
        <Box className={classes.root}>
            <div className={classes.videoContainer}>
                <VideoPlayer onPlay={onPlay} sources={[{ src: url }]} />
            </div>
        </Box>

    )
}